module.exports = __webpack_public_path__ + "static/media/2770324_equipment_kitchen_scale_scales_weight_icon.c043801a.ico";